import { createLocaleTextHook } from '@moonpig/web-core-locale-text'
import { PRODUCT_INFO_TEXT } from '../../components/ProductInfo/ProductInfo.locale'

const frictionlessFlowDictionary = {
  'common.add_to_basket': {
    'en-GB': 'Add to Basket & Select Size',
    'nl-NL': 'In winkelmand en kies maat',
  },
  'common.personalise': {
    'en-GB': 'Personalise Card',
    'nl-NL': 'Personaliseer kaart',
  },
}

export const useFrictionlessFlowLocaleText = createLocaleTextHook({
  dictionary: {
    ...PRODUCT_INFO_TEXT,
    ...frictionlessFlowDictionary,
  },
})
